import { useState, useEffect } from "react";
import { DEVICE_BREAKPOINTS } from "theme/deviceBreakpoints";
import logger from "utils/logger";

const VIEWPORT_DEBUG = process.env.REACT_APP_VIEWPORT_DEBUG === "true";

export default function useViewportInfo(label = "Viewport") {
  const getInfo = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const type =
      width >= DEVICE_BREAKPOINTS.xl
        ? "xl"
        : width >= DEVICE_BREAKPOINTS.large
        ? "large"
        : width >= DEVICE_BREAKPOINTS.medium
        ? "medium"
        : width >= DEVICE_BREAKPOINTS.laptop
        ? "laptop"
        : "small";

    return { width, height, type };
  };

  const [viewport, setViewport] = useState(getInfo());

  useEffect(() => {
    const handleResize = () => {
      const info = getInfo();
      setViewport(info);
      if (VIEWPORT_DEBUG) {
        logger.debug(`${label}: ${info.width}x${info.height} — ${info.type}`);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [label]);
  return viewport;
}
